// Disturber.js
import React, { useState, useEffect } from 'react';
import './Disturber.css';

function Disturber() {
    const [primaryOpacity, setPrimaryOpacity] = useState(1);
    const [secondaryOpacity, setSecondaryOpacity] = useState(0);
    const [scrollY, setScrollY] = useState(0);
    const movementFactor = 0.25;
    const disturberRef = React.useRef(null);
    
    const columnMultipliers = [
        0.2,  // First column (slowest)
        0.28,  // Second column (fastest)
        0.25,  // Third column (a bit slower than second)
        0.15   // Fourth column (slow)
    ];

    useEffect(() => {
        const handleScroll = () => {
            const viewportHeight = window.innerHeight;
            const scrollPosition = window.scrollY;
            const disturberTop = disturberRef.current.offsetTop;
            const disturberHeight = disturberRef.current.offsetHeight;
    
            // Verificar se a div 'disturber' está visível no viewport
            if (scrollPosition + viewportHeight > disturberTop && scrollPosition < disturberTop + disturberHeight) {
                const visiblePortion = scrollPosition + viewportHeight - disturberTop;
                setScrollY(visiblePortion);
    
                const percentageScrolled = visiblePortion / disturberHeight;
    
                if (percentageScrolled < 0.6) {
                    setPrimaryOpacity(1);
                    setSecondaryOpacity(0);
                } else if (percentageScrolled < 0.8) {
                    const transitionFactor = (0.8 - percentageScrolled) * 5; // Range between 0.4 to 0.6
                    setPrimaryOpacity(transitionFactor);
                    setSecondaryOpacity(1 - transitionFactor);
                } else {
                    setPrimaryOpacity(0);
                    setSecondaryOpacity(1);
                }
            } else if (scrollPosition >= disturberTop + disturberHeight) {
                setScrollY(disturberHeight);
            } else {
                setScrollY(0);
            }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);
    
    
    
    
    

    return (
        <div className="disturber" ref={disturberRef}>
            <div 
                className="column column1" 
                style={{ height: `${Math.min(scrollY * movementFactor * columnMultipliers[0], 100)}%` }}
            ></div>
            <div 
                className="column column2" 
                style={{ height: `${Math.min(scrollY * movementFactor * columnMultipliers[1], 100)}%` }}
            ></div>
            <div 
                className="column column3" 
                style={{ height: `${Math.min(scrollY * movementFactor * columnMultipliers[2], 100)}%` }}
            ></div>
            <div 
                className="column column4" 
                style={{ height: `${Math.min(scrollY * movementFactor * columnMultipliers[3], 100)}%` }}
            ></div>
            
            <div className="text-wrapper">
                <div className="primary-text" style={{ opacity: primaryOpacity }}>
                    Sé parte de nuestra paleta
                </div>
                <div className="secondary-text" style={{ opacity: secondaryOpacity }}>
                    Como ellos lo hicieron
                </div>
            </div>

        </div>
    );
}

export default Disturber;
